export const OfficeUserCreateState = {
	url: '/create',
	title: 'Office Create User',
	template: '<user-create></user-create>',
	lazyLoad: $transition$ => {
		const $ocLazyLoad = $transition$.injector().get('$ocLazyLoad');
		const $log = $transition$.injector().get('$log');
		return import(
			/* webpackChunkName: "officeUsersCreatePageMod" */
			'@Containers/office-users-page/create/office-user-create.cmp.js'
		)
			.then(res => $ocLazyLoad.load({name: res.default}))
			.catch(err => $log.error(err));
	},
};
